import React from 'react';
import RecoverDialog from './recover-dialog';

export default function RecoverPage() {
  return <RecoverDialog open />;
}
